import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WhyChooseProMarketing from "./sections/WhyChooseProMarketing";
import FeaturedPortfolio from "./sections/FeaturedPortfolio";
import Prezzario from "./sections/Prezzario";
import INostriClienti from "./sections/INostriClienti";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WhyChooseProMarketing />
      <FeaturedPortfolio />
      <Prezzario />
      <INostriClienti />
      <Footer />
    </div>;
}